import React, { useContext } from 'react';
import styled from 'styled-components';
import { MAX_MOBILE_WIDTH_IN_PX } from '../constants';
import { MainNavigationContext } from '../MainNavigationContext';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
const MobileListItem = styled.li `
  font-size: 1.125rem;
  line-height: 1.33;
  margin-left: 0;

  &:first-of-type {
    margin-left: 0;
  }
`;
const DesktopListItem = styled.li `
  /* Required to center cart icon vertically */
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 1;

  margin-left: ${props => (props.isLoggedIn ? 2.5 : 2.75)}rem;

  &:first-of-type {
    margin-left: 0;
  }

  @media screen and (max-width: ${MAX_MOBILE_WIDTH_IN_PX}px) {
    margin-left: 0;
  }
`;
export const SecondaryNavigationItem = ({ children }) => {
    const isMobile = useIsMobileNavigation();
    const { isLoggedIn } = useContext(MainNavigationContext);
    return isMobile ? (React.createElement(MobileListItem, null, children)) : (React.createElement(DesktopListItem, { isLoggedIn: isLoggedIn }, children));
};
